export enum SearchType {
  CONVERSATIONS = 'CONVERSATIONS',
  MESSAGES = 'MESSAGES',
  CLIENTS = 'CLIENTS',
  PAYMENTS = 'PAYMENTS',
  PRODUCT_REQUESTS = 'PRODUCT_REQUESTS',
  FORM_SUBMISSIONS = 'FORM_SUBMISSIONS'
}
